export const timeData = [
  {
    id: 1,
    name: "Lookback",
  },
  {
    id: 2,
    name: "From",
  },
  {
    id: 3,
    name: "To",
  },
  {
    id: 4,
    name: "From + To",
  },
];

export const filterButtons = [
  { id: 1, name: "Tickets" },
  { id: 2, name: "Alarms" },
  { id: 3, name: "Assets" },
];
